import * as React from 'react'
export function Emblem({ title = 'Emblem', className, variation, ...props }) {
  return (
    <svg
      viewBox="0 0 52 70"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      data-variation={variation}
      {...props}
    >
      <title>{title}</title>
      <path
        d="M18.0954 69.9899L12.312 60.6801L1.97949 63.6246L14.7981 31.1284L30.914 37.4937L18.0954 69.9899Z"
        fill="url(#paint0_radial_9893_2722)"
      />
      <path
        d="M33.2059 69.9899L38.9893 60.6801L49.3218 63.6246L36.5031 31.1284L20.3696 37.4937L33.2059 69.9899Z"
        fill="url(#paint1_radial_9893_2722)"
      />
      <path
        d="M36.133 47.3326L33.6645 47.1033C32.0423 46.9623 30.4202 47.3678 29.0625 48.2847L26.9995 49.6776C23.9844 51.7054 19.9113 51.1235 17.5839 48.3376L15.997 46.4333C14.9567 45.1814 13.5108 44.3174 11.9063 44.0177L9.47305 43.5416C5.8937 42.8363 3.44282 39.5567 3.7602 35.9245L3.98942 33.456C4.13048 31.8338 3.72494 30.2117 2.80806 28.854L1.41511 26.791C-0.612595 23.7759 -0.0307307 19.7028 2.75516 17.3754L4.65945 15.7885C5.91133 14.7482 6.77531 13.3023 7.07506 11.6978L7.55113 9.26455C8.25642 5.68521 11.536 3.23432 15.1683 3.55171L17.6368 3.78092C19.2589 3.92198 20.8811 3.51644 22.2388 2.59956L24.3018 1.20662C27.3169 -0.821091 31.3899 -0.239227 33.7174 2.54667L35.3043 4.45095C36.3446 5.70284 37.7904 6.56682 39.395 6.86657L41.8282 7.34264C45.4076 8.04793 47.8584 11.3275 47.5411 14.9598L47.3118 17.4283C47.1708 19.0504 47.5763 20.6726 48.4932 22.0303L49.8861 24.0933C51.9139 27.1084 51.332 31.1814 48.5461 33.5089L46.6418 35.0958C45.3899 36.1361 44.5259 37.5819 44.2262 39.1865L43.7501 41.6197C43.0448 45.1991 39.7652 47.6499 36.133 47.3326Z"
        fill="#3300FF"
      />
      <path
        d="M25.642 43.3831C35.5553 43.3831 43.5916 35.3468 43.5916 25.4335C43.5916 15.5202 35.5553 7.48389 25.642 7.48389C15.7287 7.48389 7.69238 15.5202 7.69238 25.4335C7.69238 35.3468 15.7287 43.3831 25.642 43.3831Z"
        fill="url(#paint2_radial_9893_2722)"
      />
      <path
        d="M16.8384 21.2207L13.0107 25.0483L22.8853 34.9229L26.7129 31.0953L16.8384 21.2207Z"
        fill="white"
      />
      <path
        d="M38.2734 19.7061L34.4458 15.8784L19.1352 31.189L22.9629 35.0166L38.2734 19.7061Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_9893_2722"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(42.0752 17.7632) scale(49.335)"
        >
          <stop stop-color="#3B6AF5" />
          <stop offset="1" stop-color="#19AFE0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_9893_2722"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(44.4905 16.1586) scale(48.471 48.471)"
        >
          <stop stop-color="#3B6AF5" />
          <stop offset="1" stop-color="#19AFE0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_9893_2722"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(38.4783 16.9524) scale(35.9169 35.9169)"
        >
          <stop stop-color="#3B6AF5" />
          <stop offset="1" stop-color="#19AFE0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
export default Emblem
